import React from 'react';

import type { SxProps } from '@mui/material';

import { Box, Button, Skeleton, styled, Typography } from '@liscio/ui';

import { AppHeaderWrapper } from 'components';

export interface HeaderProps {
  title: string;
  isLoading?: boolean;
  numberOfItems?: number | null;
  onSeeAllClick: () => void;
  actions?: React.ReactNode;
  sx?: SxProps;
}

const Wrapper = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

const TitleWrapper = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
});

const Title = styled(Typography)({
  fontSize: '18px',
  fontWeight: '600',
  lineHeight: '24px',
});

const ActionsWrapper = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
});

export const Header: React.FC<HeaderProps> = ({
  title,
  isLoading,
  numberOfItems,
  onSeeAllClick,
  actions,
  sx,
}) => {
  return (
    <AppHeaderWrapper sx={sx}>
      <Wrapper>
        <TitleWrapper>
          <Title>{title}</Title>
          <Title>|</Title>
          {isLoading && <Skeleton sx={{ width: 30 }} />}
          {!isLoading && <Title>{numberOfItems}</Title>}
        </TitleWrapper>
        <ActionsWrapper>
          {actions}
          <Button onClick={onSeeAllClick}>See All</Button>
        </ActionsWrapper>
      </Wrapper>
    </AppHeaderWrapper>
  );
};

export default Header;
